import { bdrCalendarsApiConnector } from 'apiConnector/bdr-calendar';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap, timeoutWith } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  bdrValuationCalendarsBlackoutDatesFailed,
  bdrValuationCalendarsBlackoutDatesReceived,
  bdrValuationCalendarsBlackoutDatesTimeouted,
} from 'state/valuationDateCalendars/valuationDateCalendars.action';
import type { BdrValuationCalendarsBlackoutDatesState } from 'state/valuationDateCalendars/valuationDateCalendars.model';

export type BdrValuationCalendarsBlackoutDatesMap = BdrValuationCalendarsBlackoutDatesState;

export interface FetchValuationCalendarsBlackoutDatesEpicApi {
  getValuationCalendarsBlackoutDates(calendarCodes: string[]): Observable<BdrValuationCalendarsBlackoutDatesMap>;
}

export function fetchValuationCalendarsBlackoutDatesEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('VALUATION_CALENDARS_BLACKOUT_DATES_REQUESTED'),
      mergeMap(({ calendarCodes }) => {
        return bdrCalendarsApiConnector(httpClient)
          .getValuationCalendarsBlackoutDates(calendarCodes)
          .pipe(
            map(calendars => bdrValuationCalendarsBlackoutDatesReceived(calendars)),
            catchError(_ => of(bdrValuationCalendarsBlackoutDatesFailed())),
            timeoutWith(timeoutInMillis, of(bdrValuationCalendarsBlackoutDatesTimeouted()), appScheduler),
          );
      }),
    );
}
